import {
  CollageElementDataType,
  VideoElementDataType,
} from '@/components/sections/builder/elements/body/collage/type';
import ImageSetting from '@/components/sections/builder/settings/image-setting';
import { ElementProps } from '@/components/sections/builder/types';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

import { useBuilderStore } from '@/stores/builder';
import { Tags } from 'lucide-react';
import React from 'react';
import { shallow } from 'zustand/shallow';

const defaultData: VideoElementDataType = {
  name: 'Video',
  url: '',
  file: null,
  altText: '',
  cover: 'https://placehold.co/600x600?text=Placholder%20Video',
};

export const ElementContent = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as VideoElementDataType;
  const parentData = (element.parentData || {}) as CollageElementDataType;

  return (
    <>
      <section>
        <div
          className={cn('mx-auto', parentData.cardStyle === 'all' && 'theme_product_card')}
          data-animation='true'
        >
          <div className='video-player image_padding mx-auto'>
            <video
              poster={data.cover}
              src={data.url}
              controls
              title={data.altText}
              height='275'
              width='487'
              className={cn(
                'img h-full w-full rounded-[8px] ',
                parentData.cardStyle === 'individual' && 'theme_media'
              )}
            />
          </div>
        </div>
      </section>
      <style jsx>
        {`
          .video-player {
            aspect-ratio: 1/1;
          }
        `}
      </style>
    </>
  );
};

export const ElementPreviewIcon = Tags;

export function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
    }),
    shallow
  );

  const data = (element.data || defaultData) as VideoElementDataType;

  return (
    <div>
      <div className='mb-4 mt-4'>Cover Image</div>
      <ImageSetting
        value={data?.cover}
        onChange={(val) =>
          builder.setChildData(element.parentId as string, element.id, {
            cover: val,
          })
        }
      />
      <video src={data.url} height='144' width='250' className='w-full rounded-[8px] border' />
      <div className='mt-4 flex w-full justify-center text-center'>
        <label
          htmlFor='upload-video'
          className='w-full cursor-pointer rounded-[8px] border border-[#E4E2E2] px-6 py-3'
        >
          Change Video
        </label>
      </div>
      <input
        id='upload-video'
        type='file'
        className='hidden'
        accept='video/mp4, video/mov'
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const files = e.target.files;
          const file = files?.[0];
          const urlBlob = URL.createObjectURL(file as Blob);
          builder.setChildData(element.parentId as string, element.id, {
            file,
            url: urlBlob,
          });
        }}
      />
      <div className='my-4'>Video alt text</div>
      <Input
        name='altText'
        type='text'
        value={data.altText}
        onChange={(e) => {
          builder.setChildData(element.parentId as string, element.id, {
            altText: e.target.value,
          });
        }}
      />
    </div>
  );
}

const Product = {
  type: 'video',
  group: 'collage',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
};

export default Product;
